<div class="error-blur" *ngFor="let message of messages">
    <div class="error-pop-up" role="alert" [attr.aria-labelledby]="'error-title-' + message.id" [attr.aria-describedby]="'error-message-' + message.id">
        <h4 id="error-title-{{message.id}}">{{ message.title | translate }}</h4>
        <div class="popup-content" *ngIf="message.message" id="error-message-{{message.id}}">{{ message.message | translate }}</div>
        <div class="popup-content" *ngIf="message.innerHTML" [innerHTML]="message.innerHTML"></div>
        <button class="primary" *ngFor="let button of message.buttons" (click)="buttonClicked(message, button)">  
            {{ button.title | translate }}
        </button>
    </div>
</div>